// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__35NpY","col":"styles_col__3FRFD","fulfillmentStatus":"styles_fulfillmentStatus__3bptO","emailCol":"styles_emailCol__36PYn"};